window.updateDataset =  function updateDataset(e, datasetIndex) {
    var ctx = document.getElementById("doughnut-chart").getContext("2d");
    var ci = e.view.doughtnutChart;
    var meta = ci.getDatasetMeta(0).data[datasetIndex];

    meta.hidden = !meta.hidden;

    if(e.target.tagName.toString().toLowerCase()!=="h4"){
        $(e.target).siblings("h4").toggleClass( "strikeThrough" );
    }
    else{
        $(e.target).toggleClass("strikeThrough");
    }
    // See controller.isDatasetVisible comment
    // meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

    // We hid a dataset ... rerender the chart
    ci.update();
};